<template>
  <div class="align-items-center">
    <BaseIcon type="dns" :name="modelValue" v-if="modelValue" />
    <BaseIcon type="dns" name="file-description" v-else />
  </div>
</template>
<script>
import BaseIcon from "@/components/icons/BaseIcon";

export default {
  name: "DnsIcon",
  components: { BaseIcon },
  props: {
    id: Number,
    row: Object,
    modelValue: Boolean,
    extraRow: String,
  },
  data() {
    return {
      value: this.modelValue,
      lock: this.extraRow,
    };
  },
  watch: {
    value() {
      this.$emit("update:modelValue", this.value);
      this.$emit("update", this.value, false);
    },
    extraRow() {
      this.lock = this.extraRow;
    },
    modelValue() {
      this.value = this.modelValue;
    },
  },
  emits: ["update:modelValue", "update", "update:extraRow"],
};
</script>
